import { render, staticRenderFns } from "./resourceSelection.vue?vue&type=template&id=5723b792&scoped=true"
import script from "./resourceSelection.vue?vue&type=script&lang=js"
export * from "./resourceSelection.vue?vue&type=script&lang=js"
import style0 from "./resourceSelection.vue?vue&type=style&index=0&id=5723b792&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5723b792",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5723b792')) {
      api.createRecord('5723b792', component.options)
    } else {
      api.reload('5723b792', component.options)
    }
    module.hot.accept("./resourceSelection.vue?vue&type=template&id=5723b792&scoped=true", function () {
      api.rerender('5723b792', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/myDealChild/child/resourceSelection.vue"
export default component.exports